import { useEffect } from 'react'

import { StoreBonusStatusResponse } from '@common/models/bonus'
import cx from 'classnames'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import BsUnavailableImg from '@/assets/images/storefronts/brawlstars/bonus-track-unavailable.png'
import CocUnavailableImg from '@/assets/images/storefronts/clashofclans/bonus-track-unavailable.png'
import CrUnavailableImg from '@/assets/images/storefronts/clashroyale/bonus-track-unavailable.png'
import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useGameSlug } from '@/features/storefronts/game-provider'
import { getTimeRemaining } from '@/utils/timer'

import { BonusMissionItem } from './BonusMissionItem'
import { BonusTimeRemaining } from '../../shared/BonusTimeRemaining'

import styles from './bonusMissions.module.scss'

interface BonusPointsProps {
  bonusStatus: StoreBonusStatusResponse
}

export const BonusMissions = ({ bonusStatus }: BonusPointsProps) => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const missionsTimeLeft = bonusStatus?.missions?.endTimeMillis || 0
  const missions = bonusStatus?.missions?.missions

  useEffect(() => {
    const element = document.getElementById('bonusTrackWrapper')
    element?.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  const showRemainingTime = bonusStatus?.endTimeMillis && bonusStatus.endTimeMillis > 0

  const img =
    gameSlug === 'brawlstars' ? BsUnavailableImg : gameSlug === 'clashroyale' ? CrUnavailableImg : CocUnavailableImg

  const bonusMissionsUnavailableTextArray = t('missions_unavailable').split(' ')

  if (!missions) {
    return (
      <div className={cx(styles.contentContainer, styles.unavailable)}>
        <div className={styles.missionsTitle}>
          <StoreTypography tag="h3" textSize="lg" overrideFont="supercellHeadline" style="plain">
            {bonusMissionsUnavailableTextArray[0]}
          </StoreTypography>
          <StoreTypography tag="h3" textSize="lg" overrideFont="supercellHeadline" style="plain">
            {bonusMissionsUnavailableTextArray[1]}
          </StoreTypography>
        </div>

        <div className={styles.unavailableImg}>
          <Image src={img} alt="bonus-unavailable" fill />
        </div>
        <StoreTypography tag="h3" textSize="sm" style="plain" overrideFont="supercellText">
          {t('bonus_track_check_back')}
        </StoreTypography>
      </div>
    )
  }

  const remainingTime = getTimeRemaining(missionsTimeLeft)

  return (
    <div className={styles.contentContainer}>
      <StoreTypography
        tag="h3"
        textSize="lg"
        overrideFont="supercellHeadline"
        style="plain"
        className={styles.missionsTitle}
      >
        {t('earn_points_completing_missions')}
      </StoreTypography>

      {!!showRemainingTime && <BonusTimeRemaining remainingTime={remainingTime} gameSlug={gameSlug} />}

      <div className={styles.missionsContainer}>
        {missions.map((mission) => (
          <BonusMissionItem key={mission.missionId} mission={mission} />
        ))}
      </div>

      <div className={styles.infoContainer}>
        <span className={styles.infoCircle}>!</span>
        <StoreTypography tag="h6" textSize="xs" style="plain" overrideFont="supercellText">
          {t('bonus_time_appear')}
        </StoreTypography>
      </div>
    </div>
  )
}
